import React from 'react';

interface State {
  hasError: boolean;
  error?: Error | null;
}

export default class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Log to console so Vercel deployment logs (client-side) can capture it when opened in browser
    // The developer should check browser console for full stack and the source maps we'll enable.
    // You may replace this with a real error tracking service (Sentry, LogRocket, etc.).
    console.error('Uncaught error in component tree:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding: 24, fontFamily: 'sans-serif'}}>
          <h1 style={{color: '#BE3900'}}>Erro na aplicação</h1>
          <p>Ocorreu um erro em tempo de execução. Abra o console do navegador para mais detalhes.</p>
          <pre style={{whiteSpace: 'pre-wrap'}}>{String(this.state.error)}</pre>
        </div>
      );
    }

    return this.props.children as React.ReactElement;
  }
}
